import { ProgressBarWizard } from '@bambi/component-library/src/components/Wizard/ProgressBarWizard';

import { useAppDispatch } from 'src/app/store/hooks';
import { Modal } from 'src/common/primitives/Modal';

import { resetMergeWizard } from '../../passenger.slice';
import { ConfirmMergeStep } from './steps/ConfirmMergeStep';
import { SearchPassengersStep } from './steps/SearchPassengersStep';
import { SelectDuplicatesStep } from './steps/SelectDuplicatesStep';
import { SelectPassengerMatchFieldsStep } from './steps/SelectPassengerMatchFieldsStep';

import type { WizardStepConfig } from '@bambi/component-library/src/components/Wizard/base/types';

interface PassengerMergeModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const wizardSteps: WizardStepConfig[] = [
  {
    title: 'Narrow down',
    render: (stepProps) => {
      return <SearchPassengersStep {...stepProps} />;
    },
  },
  {
    title: 'Match fields',
    render: (stepProps) => {
      return <SelectPassengerMatchFieldsStep {...stepProps} />;
    },
  },
  {
    title: 'Select duplicates',
    render: (stepProps) => {
      return <SelectDuplicatesStep {...stepProps} />;
    },
  },
  {
    title: 'Verify selection',
    render: (stepProps) => {
      return <ConfirmMergeStep {...stepProps} />;
    },
  },
];

export function PassengerMergeModal({
  open,
  setOpen,
}: PassengerMergeModalProps) {
  const dispatch = useAppDispatch();

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      onClose={() => {
        dispatch(resetMergeWizard());
      }}
      title="Merge Passengers"
    >
      <ProgressBarWizard testId="passenger-merge-wizard" steps={wizardSteps} />
    </Modal>
  );
}
